module.exports = __webpack_public_path__ + "img/carousel-clientes-1.06f47783.png";